import request from "@/shared/libs/axios";
import { z } from "zod";

export const loginSchema = z.object({
  empNo: z
    .string()
    .min(1, "登录账户不能为空")
    .max(10, "登录账户不能超过10个字符"),
  password: z.string().min(1, "账户密码不能为空"),
});

export const bindSchema = z.object({
  openid:z.string().min(1, "openid不能为空"),
  empNo: z
      .string()
      .min(1, "登录账户不能为空")
      .max(10, "登录账户不能超过10个字符"),
  password: z.string().min(1, "账户密码不能为空"),
})


export interface QrCodeConfig {
  appId: string;
  state: string;
  qrLoginUrl: string;
  expireTime: number;
  qrCodeBase64?: string; // 可选：后端返回的二维码Base64图片
}

export interface CallBackConfig {
  status?: string;
  openid?: string;
  token?: string;
  userId?: number;
  empNo?: string; // 可选：后端返回的二维码Base64图片
}

export interface BindConfig {
  openid?: string;
  empNo?: string;
  token?: string;
  userId?: number;
}



export type LoginCredentialsDTO = z.infer<typeof loginSchema>;

export type bindUserDTO = z.infer<typeof bindSchema>;

export const login = async (data: LoginCredentialsDTO) => {
  return request.post<string, LoginCredentialsDTO>("/sys/auth/login", data);
};
export const logout = async () => {
  return request.post("/sys/auth/logout");
};

/**
 * 生成登录二维码
 */
export const getLoginQrCode = async () =>{
  return request.get<QrCodeConfig>("ext/wechat/scanCodeLogin/qrcode/config");
}

/**
 * 扫描二维码后回调
 * @param code
 * @param state
 */
export const scanQrCodeAfterCallback = async (code:string,state:string) =>{
  return request.get<CallBackConfig>("/ext/wechat/scanCodeLogin/handlePcCallback?code="+code+"&state="+state)
}

export const bindOpenidToErpUser = async (param:bindUserDTO) =>{
  return request.post<BindConfig>("/ext/wechat/scanCodeLogin/bindOpenidToErpUser",param);
}



